<template>
  <table class="table table-striped w-100 text-center" :id="nombreTabla">
    <thead>
    <tr>
      <template>
        <th class="text-md-break">Región</th>
        <th class="text-md-break border-left border-right p-0">
          <div class="d-flex flex-column justify-content-center p-0">
            <div class="d-flex justify-content-center">
              <span>Semana {{ currentWeeks[0] }}</span>
            </div>
            <div class="d-flex justify-content-around">
              <td class="border-top-0 text-md-break pl-0 pt-0 pb-0 px-3">
                <span tabindex="0" title="Planificación anual">Anual</span>
              </td>
              <td class="border-top-0 text-md-break pl-0 pt-0 pb-0 px-3">
                <span tabindex="0" title="Cliente">Semanal</span>
              </td>
              <td class="border-top-0 text-md-break p-0 px-3">
                <span tabindex="0" title="Planificación semanal"></span>
              </td>
            </div>
          </div>
        </th>
        <th class="text-md-break border-left border-right p-0">
          <div class="d-flex flex-column justify-content-center p-0">
            <div class="d-flex justify-content-center">
              <span>Semana {{ currentWeeks[1] }}</span>
            </div>
            <div class="d-flex justify-content-around">
              <td class="border-top-0 text-md-break pl-0 pt-0 pb-0 px-3">
                <span tabindex="0" title="Planificación anual">Anual</span>
              </td>
              <td class="border-top-0 text-md-break pl-0 pt-0 pb-0 px-3">
                <span tabindex="0" title="Cliente">Semanal</span>
              </td>
              <td class="border-top-0 text-md-break p-0 px-3">
                <span tabindex="0" title="Planificación semanal"></span>
              </td>
            </div>
          </div>
        </th>
        <th class="text-md-break border-left border-right p-0">
          <div class="d-flex flex-column justify-content-center p-0">
            <div class="d-flex justify-content-center">
              <span>Semana {{ currentWeeks[2] }}</span>
            </div>
            <div class="d-flex justify-content-around">
              <td class="border-top-0 text-md-break pl-0 pt-0 pb-0 px-3">
                <span tabindex="0" title="Planificación anual">Anual</span>
              </td>
              <td class="border-top-0 text-md-break pl-0 pt-0 pb-0 px-3">
                <span tabindex="0" title="Cliente">Semanal</span>
              </td>
              <td class="border-top-0 text-md-break p-0 px-3">
                <span tabindex="0" title="Planificación semanal"></span>
              </td>
            </div>
          </div>
        </th>
        <th class="text-md-break border-left border-right p-0">
          <div class="d-flex flex-column justify-content-center p-0">
            <div class="d-flex justify-content-center">
              <span>Semana {{ currentWeeks[3] }}</span>
            </div>
            <div class="d-flex justify-content-around">
              <td class="border-top-0 text-md-break pl-0 pt-0 pb-0 px-3">
                <span tabindex="0" title="Planificación anual">Anual</span>
              </td>
              <td class="border-top-0 text-md-break pl-0 pt-0 pb-0 px-3">
                <span tabindex="0" title="Cliente">Semanal</span>
              </td>
              <td class="border-top-0 text-md-break p-0 px-3">
                <span tabindex="0" title="Planificación semanal"></span>
              </td>
            </div>
          </div>
        </th>
        <th class="text-md-break border-left border-right p-0">
          <div class="d-flex flex-column justify-content-center p-0">
            <div class="d-flex justify-content-center">
              <span>Semana {{ currentWeeks[4] }}</span>
            </div>
            <div class="d-flex justify-content-around">
              <td class="border-top-0 text-md-break pl-0 pt-0 pb-0 px-3">
                <span tabindex="0" title="Planificación anual">Anual</span>
              </td>
              <td class="border-top-0 text-md-break pl-0 pt-0 pb-0 px-3">
                <span tabindex="0" title="Cliente">Semanal</span>
              </td>
              <td class="border-top-0 text-md-break p-0 px-3">
                <span tabindex="0" title="Planificación semanal"></span>
              </td>
            </div>
          </div>
        </th>
      </template>
    </tr>
    </thead>
    <tbody>
    <tr v-for="(row, index) in data" :key="index">
      <template>
        <td>{{ row.data[0] }}</td>
        <td>
          <div class="d-flex justify-content-around">
            <td class="border-top-0 text-md-break pl-0 pt-0 pb-0 px-3">
              <span tabindex="0">{{ row.data[1] }}</span>
            </td>
            <td class="border-top-0 text-md-break pl-0 pt-0 pb-0 px-3">
              <span tabindex="0">{{ row.data[2] }}</span>
            </td>
            <td class="border-top-0 text-md-break p-0 px-3">
              <Button
                :size="10"
                color="#28a745"
                colorText="#ffffff"
                tooltip="Agregar planificación semanal"
                icon="fas fa-plus"
                round
                :width="15"
                class="mr-2"
                traslate
                @click.native="viewDetail(index, currentWeeks[0])"
              />
            </td>
          </div>
        </td>
        <td>
          <div class="d-flex justify-content-around">
            <td class="border-top-0 text-md-break pl-0 pt-0 pb-0 px-3">
              <span tabindex="0">{{ row.data[3] }}</span>
            </td>
            <td class="border-top-0 text-md-break pl-0 pt-0 pb-0 px-3">
              <span tabindex="0">{{ row.data[4] }}</span>
            </td>
            <td class="border-top-0 text-md-break p-0 px-3">
              <Button
                :size="10"
                color="#28a745"
                colorText="#ffffff"
                tooltip="Agregar planificación semanal"
                icon="fas fa-plus"
                round
                :width="15"
                class="mr-2"
                traslate
                @click.native="viewDetail(index, currentWeeks[1])"
              />
            </td>
          </div>
        </td>
        <td>
          <div class="d-flex justify-content-around">
            <td class="border-top-0 text-md-break pl-0 pt-0 pb-0 px-3">
              <span tabindex="0">{{ row.data[5] }}</span>
            </td>
            <td class="border-top-0 text-md-break pl-0 pt-0 pb-0 px-3">
              <span tabindex="0">{{ row.data[6] }}</span>
            </td>
            <td class="border-top-0 text-md-break p-0 px-3">
              <Button
                :size="10"
                color="#28a745"
                colorText="#ffffff"
                tooltip="Agregar planificación semanal"
                icon="fas fa-plus"
                round
                :width="15"
                class="mr-2"
                traslate
                @click.native="viewDetail(index, currentWeeks[2])"
              />
            </td>
          </div>
        </td>
        <td>
          <div class="d-flex justify-content-around">
            <td class="border-top-0 text-md-break pl-0 pt-0 pb-0 px-3">
              <span tabindex="0">{{ row.data[7] }}</span>
            </td>
            <td class="border-top-0 text-md-break pl-0 pt-0 pb-0 px-3">
              <span tabindex="0">{{ row.data[8] }}</span>
            </td>
            <td class="border-top-0 text-md-break p-0 px-3">
              <Button
                :size="10"
                color="#28a745"
                colorText="#ffffff"
                tooltip="Agregar planificación semanal"
                icon="fas fa-plus"
                round
                :width="15"
                class="mr-2"
                traslate
                @click.native="viewDetail(index, currentWeeks[3])"
              />
            </td>
          </div>
        </td>
        <td>
          <div class="d-flex justify-content-around">
            <td class="border-top-0 text-md-break pl-0 pt-0 pb-0 px-3">
              <span tabindex="0">{{ row.data[9] }}</span>
            </td>
            <td class="border-top-0 text-md-break pl-0 pt-0 pb-0 px-3">
              <span tabindex="0">{{ row.data[10] }}</span>
            </td>
            <td class="border-top-0 text-md-break p-0 px-3">
              <Button
                :size="10"
                color="#28a745"
                colorText="#ffffff"
                tooltip="Agregar planificación semanal"
                icon="fas fa-plus"
                round
                :width="15"
                class="mr-2"
                traslate
                @click.native="viewDetail(index, currentWeeks[4])"
              />
            </td>
          </div>
        </td>
      </template>
    </tr>
    </tbody>
    <tfoot>
    <tr>
      <td class="text-center">
        <div style="font-weight: 700;font-size: 14px !important; margin-top:2.5px">Total Semanal:</div>
      </td>
      <td class="text-center">
        <div class="d-flex justify-content-around">
          <td class="border-top-0 text-md-break pl-0 pt-0 pb-0 px-0">
            <span tabindex="0"><b>{{ weeksTotals.week1[0] }}</b></span>
          </td>
          <td class="border-top-0 text-md-break pl-0 pt-0 pb-0">
            <span tabindex="0"><b>{{ weeksTotals.week1[1] }}</b></span>
          </td>
          <td class="border-top-0 text-md-break pl-0 pt-0 pb-0">
            <span tabindex="0"><b>-</b></span>
          </td>
        </div>
      </td>
      <td>
        <div class="d-flex justify-content-around">
          <td class="border-top-0 text-md-break pl-0 pt-0 pb-0 px-0">
            <span tabindex="0"><b>{{ weeksTotals.week2[0] }}</b></span>
          </td>
          <td class="border-top-0 text-md-break pl-0 pt-0 pb-0">
            <span tabindex="0"><b>{{ weeksTotals.week2[1] }}</b></span>
          </td>
          <td class="border-top-0 text-md-break pl-0 pt-0 pb-0">
            <span tabindex="0"><b>-</b></span>
          </td>
        </div>
      </td>
      <td>
        <div class="d-flex justify-content-around">
          <td class="border-top-0 text-md-break pl-0 pt-0 pb-0 px-0">
            <span tabindex="0"><b>{{ weeksTotals.week3[0] }}</b></span>
          </td>
          <td class="border-top-0 text-md-break pl-0 pt-0 pb-0">
            <span tabindex="0"><b>{{ weeksTotals.week3[1] }}</b></span>
          </td>
          <td class="border-top-0 text-md-break pl-0 pt-0 pb-0">
            <span tabindex="0"><b>-</b></span>
          </td>
        </div>
      </td>
      <td>
        <div class="d-flex justify-content-around">
          <td class="border-top-0 text-md-break pl-0 pt-0 pb-0 px-0">
            <span tabindex="0"><b>{{ weeksTotals.week4[0] }}</b></span>
          </td>
          <td class="border-top-0 text-md-break pl-0 pt-0 pb-0">
            <span tabindex="0"><b>{{ weeksTotals.week4[1] }}</b></span>
          </td>
          <td class="border-top-0 text-md-break pl-0 pt-0 pb-0">
            <span tabindex="0"><b>-</b></span>
          </td>
        </div>
      </td>
      <td>
        <div class="d-flex justify-content-around">
          <td class="border-top-0 text-md-break pl-0 pt-0 pb-0 px-0">
            <span tabindex="0"><b>{{ weeksTotals.week5[0] }}</b></span>
          </td>
          <td class="border-top-0 text-md-break pl-0 pt-0 pb-0">
            <span tabindex="0"><b>{{ weeksTotals.week5[1] }}</b></span>
          </td>
          <td class="border-top-0 text-md-break pl-0 pt-0 pb-0">
            <span tabindex="0"><b>-</b></span>
          </td>
        </div>
      </td>
    </tr>
    </tfoot>
  </table>
</template>

<script>
import { mapActions, mapState } from "vuex";

import $ from "jquery";
import { getPuertosPlanificacionSemanal } from "@/constants/charter";
import Button from "@/components/common/Button.vue";

export default {
  components: { Button },
  data() {
    return {
      loading: true,
      lang: {
        lengthMenu: "Display _MENU_ records per page",
        zeroRecords: "No se encontraron registros coincidentes",
        info: "Mostrando página _PAGE_ de _PAGES_",
        infoEmpty: "No hay registros disponibles",
        infoFiltered: "(filtrado de _MAX_ registros totales)",
        search: "Buscar",
        paginate: {
          first: "Primero",
          last: "Último",
          next: "Siguiente",
          previous: "Anterior"
        }
      },
      nombreTabla: "id_tabla_" + this.idtabla
    };
  },
  props: {
    weeksTotals: Object,
    currentWeeks: Array,
    admin: Boolean,
    //headers: Array, // Titulos para cabecera de la tabla
    data: Array, // Contenido o información que mostrara la tabla
    acciones: Array, // Array de configuraciones para botones de la columna "Acciones"
    paginacion: Boolean, // Si la tabla tedra activa la opción de paginación, esta opción esta deshabilitada por defecto
    max: { type: Number, default: 10 }, // Numero de filas por cada pagina
    buscar: Boolean, // Filtrar filas, esta opción esta deshabilitada por defecto
    idtabla: {
      type: String,
      default: "id_generico"
    }
  },
  computed: {
    ...mapState(["zIndexModal", "zIndexTablaModal"])
  },
  methods: {
    // Acciones de Vuex
    ...mapActions(["ActionSetLoading"]),
    ...mapActions("charter", [
      "actionSetDataDatatableDetailPSCharter",
      "actionSetListaPuertosPSCharter",
      "actionSetShowDetailPSCharter",
      "actionSetCurrentRegionPSCharter",
      "actionSetCurrentWeekPSCharter",
      "actionSetCreateModePSCharter"
    ]),
    configuracionDatatable() {
      let me = this;

      $("#" + this.nombreTabla)
        .DataTable()
        .destroy();

      $("#" + me.nombreTabla)
        .DataTable({
          paging: this.paginacion,
          pageLength: this.max,
          searching: this.buscar,
          lengthChange: false,
          ordering: true,
          info: true,
          autoWidth: false,
          responsive: true,
          checkd: false,
          language: me.lang
        })
        .buttons()
        .container()
        .appendTo("#" + me.nombreTabla + "_wrapper .col-md-6:eq(0)");
    },

    async viewDetail(index, week_number) {

      this.$vToastify.loader("Espere por favor...");

      const route_id = this.data[index].data_complementaria.route_id;

      let response = await getPuertosPlanificacionSemanal(route_id);

      this.actionSetCurrentRegionPSCharter([route_id, this.data[index].data[0]]);

      this.actionSetCurrentWeekPSCharter(week_number);

      if (response.code === 200) {

        this.actionSetListaPuertosPSCharter(response.data);

        this.actionSetShowDetailPSCharter(true);

      } else {

        this.$vToastify.error("No se puede mostrar el detalle de planificación para la semana " + week_number, "Error");
      }

      this.actionSetDataDatatableDetailPSCharter(this.data[index].data_complementaria.weeks[week_number]);

      this.$vToastify.stopLoader();

    },
  },
  mounted() {
    let me = this;
    me.configuracionDatatable();
  },
  watch: {
    data: function(_new) {
      let me = this;

      if (_new) {

        $("#" + this.nombreTabla)
          .DataTable()
          .destroy();

        setTimeout(() => {
          me.data = _new;
        }, 300);

        setTimeout(() => {
          me.configuracionDatatable();
          me.ActionSetLoading(false);
        }, 700);
      }
    }
  }
};
</script>

<style scoped>
.table thead th {
  vertical-align: middle !important;
}

thead > th {
  font-size: 13px !important;
  font-weight: 700;
}

tbody > th {
  font-size: 13px !important;
  font-weight: 700;
}

.hide-button-excel {
  display: none;
}

.buttons-colvis {
  background-color: #dc3545;
  color: #ffff;
  padding: 6px;
  border: none;
  border-radius: 3px;
  font-size: 15px;
}

.buttons-colvis:hover {
  background-color: #bd2130;
  border: none;
}

div.dataTables_wrapper div.dataTables_info {
  font-size: 13px !important;
}

.icono {
  opacity: 0.7;
}

.icono:hover {
  opacity: 1;
}

.btn-group-sm > .btn,
.btn-sm {
  padding: 0.25rem 0.45rem !important;
}

/* Table compact */

table.dataTable.compact thead th,
table.dataTable.compact thead td {
  padding: 3px 5px;
}

table.dataTable.compact tfoot th,
table.dataTable.compact tfoot td {
  padding: 3px;
}

table.dataTable.compact tbody th,
table.dataTable.compact tbody td {
  padding: 3px;
}

/* Table Hover */

table.dataTable.hover > tbody > tr:hover > * {
  box-shadow: inset 0 0 0 9999px rgba(0, 0, 0, 0.087) !important;
}

/* Stripe (Pintado de tabla estilo cebra) */

table.dataTable.stripe > tbody > tr.odd > *,
table.dataTable.display > tbody > tr.odd > * {
  box-shadow: inset 0 0 0 9999px rgba(0, 0, 0, 0.048);
}

/*  */

table.dataTable thead > tr > th.sorting,
table.dataTable thead > tr > th.sorting_asc,
table.dataTable thead > tr > th.sorting_desc,
table.dataTable thead > tr > th.sorting_asc_disabled,
table.dataTable thead > tr > th.sorting_desc_disabled,
table.dataTable thead > tr > td.sorting,
table.dataTable thead > tr > td.sorting_asc,
table.dataTable thead > tr > td.sorting_desc,
table.dataTable thead > tr > td.sorting_asc_disabled,
table.dataTable thead > tr > td.sorting_desc_disabled {
  cursor: pointer;
  position: relative;
  padding: 10px 0 !important;
  text-align: center;
}
</style>